import { render, staticRenderFns } from "./PostCreateEdit.vue?vue&type=template&id=644006e6&"
import script from "./PostCreateEdit.vue?vue&type=script&lang=js&"
export * from "./PostCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports